import React, { useState, useEffect } from "react";
import { fetchCategories, addCategory } from "../services/api";
import Select from "react-select";

const formatCategories = (categories) => {
  const map = {};
  
  categories.forEach((category) => {
    map[category.cat_id] = category;
  });

  return categories.map((category) => {
    const parentName = category.parent ? map[category.parent.cat_id]?.cat_name : null;
    return {
      value: category.cat_id,
      //label: parentName ? `${category.cat_name} (${parentName})` : category.cat_name,
      label: parentName ? `${category.cat_name}` : category.cat_name,

    };
  });
};

const AddCategoryPage = () => {

  const userRole = sessionStorage.getItem("userRole");
  const userProject = sessionStorage.getItem("project");

  // Determine the default initial project based on who is logged in
  const getInitialProject = () => {
    if (userRole !== "super_admin" && userProject) {
      return userProject;
    }
    return "jagranquiz";
  };

  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [parentCategory, setParentCategory] = useState(null);
  const [language, setLanguage] = useState("en_US");
  const [project, setProject] = useState(getInitialProject);
  const [description, setDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false); // Success popup state

  useEffect(() => {

    const projectFilter = userRole !== "super_admin" ? userProject : null;
    const fetchData = async () => {
      try {
        const fetchedCategories = await fetchCategories(projectFilter);
        setCategories(fetchedCategories);
      } catch (error) {
        setError("Failed to load categories");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formattedCategories = formatCategories(categories);

  const handleAddCategory = async () => {
    if (!newCategory.trim()) {
      setError("Category name cannot be empty");
      return;
    }

    const categoryData = {
      cat_name: newCategory,
      description: description.trim(),
      language,
      isActive,
     project: project.trim(),
      parent: parentCategory ? { cat_id: parentCategory.value, cat_name: parentCategory.label } : null,
    };

    try {
      await addCategory(categoryData);
       const projectFilter = userRole !== "super_admin" ? userProject : null;
      const fetchedCategories = await fetchCategories(projectFilter);
      setCategories(fetchedCategories);

      // Reset form fields
      setNewCategory("");
      setParentCategory(null);
      setDescription("");
      setLanguage("en_US");
      setProject(getInitialProject());
      setIsActive(true);
      setError("");

      // Show success popup
      setShowSuccessPopup(true);

      // Hide popup automatically after 3 seconds
      setTimeout(() => setShowSuccessPopup(false), 3000);
    } catch (error) {
      setError("Failed to add category");
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Add New Category</h1>

      {loading ? (
        <p>Loading categories...</p>
      ) : (
        <>
          <div style={styles.formContainer}>
            {/* Parent Category Dropdown */}
            <div style={styles.formGroup}>
              <label style={styles.label}>Parent Category</label>
              <Select
                options={formattedCategories}
                onChange={(option) => setParentCategory(option)}
                value={parentCategory}
                isClearable
                placeholder="Select parent category (optional)"
                styles={styles.dropdownSelect}
              />
            </div>

            {/* Category Name */}
            <div style={styles.formGroup}>
              <label style={styles.label}>Category Name</label>
              <input
                type="text"
                value={newCategory}
                onChange={(e) => setNewCategory(e.target.value)}
                placeholder="Enter category name"
                style={styles.input}
              />
            </div>

            {/* Language */}
            <div style={styles.formGroup}>
              <label style={styles.label}>Language</label>
              <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                style={styles.select}
              >
                <option value="en_US">English (US)</option>
                <option value="hi_IN">Hindi (IN)</option>
              </select>
            </div>



 {/* Project Selection Dropdown: Custom Role Handling */}
            <div style={styles.formGroup}>
              <label style={styles.label}>Project</label>
              <select
                value={project}
                onChange={(e) => setProject(e.target.value)}
                style={styles.select}
                disabled={userRole !== "super_admin"} // Block switching for normal Admins/Users
              >
                {userRole === "super_admin" ? (
                  <>
                    <option value="jagranquiz">Jagran</option>
                    <option value="joshquiz">Josh</option>
                  </>
                ) : (
                  <option value={userProject}>
                    {userProject === "joshquiz" ? "Josh" : "Jagran"}
                  </option>
                )}
              </select>
            </div>
            

            {/* Description */}
            <div style={styles.formGroup}>
              <label style={styles.label}>Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter category description"
                style={styles.textarea}
              />
            </div>

            {/* Is Active */}
            <div style={styles.checkboxContainer}>
              <label style={styles.label}>
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  style={styles.checkbox}
                />
                Is Active
              </label>
            </div>

            {/* Add Category Button */}
            <button onClick={handleAddCategory} style={styles.button}>
              Add Category
            </button>

            {/* Error Message */}
            {error && <p style={styles.error}>{error}</p>}
          </div>

          {/* Success Popup */}
          {showSuccessPopup && (
            <div style={styles.successPopup}>
              <div style={styles.successPopupContent}>
                <p>Category added successfully!</p>
                <button
                  onClick={() => setShowSuccessPopup(false)}
                  style={styles.closeButton}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#333",
  },
  formContainer: {
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
    width: "100%",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#333",
  },
  input: {
    padding: "10px",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
  },
  select: {
    padding: "10px",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
  },
  textarea: {
    padding: "10px",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
    height: "100px",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  checkbox: {
    marginRight: "10px",
  },
  button: {
    padding: "10px 15px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
  error: {
    color: "red",
    marginTop: "10px",
  },
  dropdownSelect: {
    control: (provided) => ({
      ...provided,
      width: "100%",
      minWidth: "300px",
    }),
  },
  successPopup: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 255, 0, 0.6)", // Green semi-transparent background
    display: "flex",
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically
    zIndex: 1000, // Ensure it appears above all content
  },
  successPopupContent: {
    backgroundColor: "#fff", // White popup background
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Shadow for popup
  },
  closeButton: {
    marginTop: "10px",
    padding: "8px 12px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
  
};

export default AddCategoryPage;
